var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.466064,
    y: 0.136108,
    width: 20.9496,
    height: 20.9496,
    rx: 3.9904,
    fill: "#FF0080"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.603585,
    d: "M15.4303 15.1001H14.6141V6.93792H7.67627V6.1217H15.0222C15.2475 6.1217 15.4303 6.30454 15.4303 6.52981V15.1001Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.85977 7.75415H13.3895C13.6148 7.75415 13.7976 7.93698 13.7976 8.16226V15.5082C13.7976 15.7335 13.6148 15.9163 13.3895 15.9163H6.85977C6.63449 15.9163 6.45166 15.7335 6.45166 15.5082V8.16226C6.45166 7.93698 6.63449 7.75415 6.85977 7.75415ZM8.0843 13.8758H10.533V13.0596H8.0843V13.8758ZM12.1654 12.2434H8.0843V11.4271H12.1654V12.2434ZM8.0843 10.6109H12.1654V9.79468H8.0843V10.6109Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.a8083e65.svg";
export { ForwardRef as ReactComponent };